<div class="searchable-dropdown relative">
    <input type="text" id="address"
           class="floating-field-cus peer"
           placeholder=""
           [ngModel]="isListVisible() ? searchText() : addressText()"
           (ngModelChange)="onInputChange($event)"
           autocomplete="off"
           [disabled]="isDisabled()"
           (focus)="onInputFocus()"
           (blur)="onInputBlur()">
    @if (isListVisible()) {
        <ul class="list absolute w-full bg-bg-white border border-gray-200 rounded mt-1 max-h-60 overflow-y-auto z-10 shadow-lg">
            @if (filteredOptions().length === 0) {
                <li class="item p-2 text-sm text-gray-500 text-center">
                    No addresses found
                </li>
            } @else {
                @for (option of filteredOptions(); track option.id) {
                    <li class="item p-2 hover:bg-gray-100 text-sm cursor-pointer"
                        (click)="onOptionSelected(option.id)">
                        {{ option.text }}
                    </li>
                }
            }
        </ul>
    }
    <label for="address" class="floating-lbl absolute left-2 -top-2.5 bg-white px-1 text-sm text-gray-600">
        {{ labelName() }} <span class="text-red-700">*</span>
    </label>
</div>